/**
* reducers for the fund
*
* Created by Min on 16/08/18
*/

import C from '../constants'

const initState = {
    fundInfoData: {},
    membersTrusteesInfoData: [],
    isLoading: false,
}

export const fundState = (state = initState, action) => {

    switch(action.type) {
        case C.SET_FUND_INFO_DATA:
            const fundInfoData = {
                'fund_name': action.payload['fund_name'],
                'fund_type': 'Individual',
                'jurisdiction' : action.payload['jurisdiction']
            }
            return {
                ...state,
                fundInfoData: fundInfoData
            }

        case C.SET_MEMBERS_TRUSTEES_DATA:
            return {
                ...state,
                membersTrusteesInfoData: getMemberTrusteeData(action.payload)
            }

        case C.SET_FUND_LOADER:
            return {
                ...state,
                isLoading: action.payload
            }
        default: return state
    }
}


// get the title of the member/truess
function getMemberTrusteeTitle (index, fundData) {
    switch (index) {
        // Trustee 2 is the special case.
        // When fundData['trustees'] is not empty, meaning the Trustee 2 is not a member
        case 1:
            if (fundData['trustees'].length == 0){
              return `Member & Trustee ${index+1}`
            }
            else{
                return `Trustee ${index+1}`
            }

        default:
            return `Member & Trustee ${index+1}`
    }
}

// get refined data of member truste
function getMemberTrusteeData (fundData){
    let allMemberTrustee = fundData['members'].concat(fundData['trustees'])
    const fundMembersTrusteesData = allMemberTrustee.map(
        (ele,index) => {
            return (
                {
                    'heading': getMemberTrusteeTitle(index,fundData),
                    'data': ele
                }
            )
        }
    )

    return fundMembersTrusteesData
}



// WEBPACK FOOTER //
// ./src/reducers/fundReducers.js